import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'px-8 py-3 font-heading font-semibold transition-all duration-300 tracking-wider uppercase text-sm relative overflow-hidden group';
  const variants = {
    primary: 'bg-amber-glow/10 border border-amber-glow text-amber-glow hover:bg-amber-glow hover:text-obsidian shadow-[0_0_15px_rgba(212,165,116,0.15)] hover:shadow-[0_0_25px_rgba(212,165,116,0.4)]',
    secondary: 'bg-charcoal border border-smoke text-bone hover:border-crimson hover:text-crimson-300',
    ghost: 'text-bone/70 hover:text-amber-glow hover:bg-white/5'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-160">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-161">
        {children}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 bg-amber-glow/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-162" />}
    </motion.button>;
}